import { useUserAgent } from './useUserAgent';

export const useIsIOS = () => {
  const userAgent = useUserAgent();
  return userAgent.includes('iPhone') || userAgent.includes('iPad');
};
